import React from "react";

const InputFile = ({ children, onChange, multiple = "multiple", accept }) => {
    const inputFileRef = React.useRef();

    const onFileChangeCapture = (e) => {
        onChange(e.target.files);
        inputFileRef.current.value = '';
    };

    const onBtnClick = () => {
        inputFileRef.current.click();
    };

    return (
        <>
            <input
                multiple={multiple}
                className="d-none"
                type="file"
                accept={accept}
                ref={inputFileRef}
                onChangeCapture={onFileChangeCapture}
            />
            {React.cloneElement(children, { onClick: onBtnClick })}
        </>
    );
};

export default InputFile;
